import { useNavigate } from "react-router-dom";
import Zoom from 'react-reveal/Zoom';
import Fade from 'react-reveal/Fade';

const AddOnComponent = () => {

    const navigate = useNavigate();

    return (
        <div className="bg-primary h-full w-full px-[30px] pb-[150px] ">
            <div className="h-[550px] md:h-[350px] bg-midnight rounded-[45px] flex items-center relative overflow-hidden">
                <Zoom>
                    <div className="absolute h-[200px] w-[200px] rounded-[50%] bg-gradient-to-b from-accent to-darkaccent top-[-60px] left-[-50px]"></div>
                </Zoom>
                <Zoom>
                    <div className="absolute h-[150px] w-[150px] border-[25px] border-accent rounded-[50%] bottom-[-50px] right-[-40px]"></div>
                </Zoom>
                <div className="flex flex-col items-center justify-center px-[5%] md:px-[20%]  gap-[10px] lg:gap-[20px]">
                    <div className="border-2 border-darkaccent w-[75px]"></div>
                    <Zoom delay={300}>
                        <div>
                            <p className="text-[25px] lg:text-[46px] font-montserrat text-white font-[600] text-center">Let's Work Together</p>
                            <p className="text-[14px] lg:text-[18px] font-poppins text-ash text-center leading-[1.5rem]" >The technological revolution is changing aspect of our lives, and the fabric of society itself. it's also changing the way we learn and what we learn
                            </p>
                        </div>
                    </Zoom>
                    <Fade bottom delay={60}>
                        <div className="w-[200px] h-[60px] flex justify-center items-center mt-8 text-primary rounded-[14px] font-montserrat text-[16px] font-[500] cursor-pointer bg-[transparent] bg-gradient-to-r from-secondary to-text  hover:bg-gradient-to-l transition-all duration-[1000ms] whitespace-nowrap shadow-text" onClick={() => { navigate("/contact") }}
                        >Contact Me</div>
                    </Fade>
                </div>
            </div>
        </div>);
}

export default AddOnComponent;